import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        position: 'relative', 
        display: 'flex', 
        flexDirection: 'column', 
        color: '#fff', 
        fontFamily: 'Montserrat, sans-serif', 
        fontSize: 18, 
        borderBottom: '1px solid rgba(0,0,0,.3)', 
        width: '100%', 
        textAlign: 'center', 
        paddingTop: 20, 
        paddingBottom: 20
    },
    wrap: {
        display: 'flex', 
        alignItems: 'center', 
        flexDirection: 'column', 
        marginBottom: 8
    },
    helper: {
        color: 'hsla(0,0%,100%,.5)',
        width: '100%',
        fontSize: '14px',
        fontFamily: 'PT-sans, sans-serif',
        paddingBottom: 4
    },
    fs: {
        fontSize: 14
    },
    w50: {
        width: '50%'
    },
    description: {
        color: '#fff',
        fontSize: 14,
        fontFamily: 'PT-sans, sans-serif',
        textTransform: 'capitalize'
    },
    btn: {
        padding: '7px 10px',
        width: '50%',
        background: '#e0d504',
        borderRadius: 8,
        fontSize: 14,
        color: 'rgb(27, 32, 57)'
    },
    wrapBtn: {
        display: 'flex', 
        justifyContent: 'center', 
        marginTop: 8,
        width: '100%'
    },
    wrapBlockDescription: {
        padding: '0 20px', 
        display: 'flex', 
        justifyContent: 'space-between', 
        columnGap: 5
    }
}))

export {
    useStyles
}